import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo, scrollToId } from "./Logo";

const links = [
  ["ansatz", "Ansatz"],
  ["leistungen", "Leistungen"],
  ["ablauf", "Ablauf"],
  ["team", "Team"],
  ["faq", "FAQ"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => { setScrolled(window.scrollY > 24); };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); };
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled ? "border-b border-[var(--line)] bg-[#F3F0EA]/85 backdrop-blur-xl" : "border-b border-transparent"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <button data-testid="nav-logo" onClick={() => window.__lenis?.scrollTo(0)} aria-label="Aufbruchwerk Startseite">
          <Logo />
        </button>
        <nav className="hidden items-center gap-9 lg:flex">
          {links.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="group relative text-sm text-[var(--ink-2)] transition-colors hover:text-[var(--ink)]">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[var(--clay)] transition-transform duration-500 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="nav-cta-button" onClick={() => go("kontakt")} className="hidden items-center gap-2 rounded-full bg-[var(--ink)] px-5 py-2.5 text-sm text-[var(--stone)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[var(--clay)] sm:flex">
            Erstgespräch <ArrowUpRight className="h-4 w-4" />
          </button>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="rounded-full border border-[var(--ink)]/20 p-2.5 lg:hidden" aria-label="Menü">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="border-t border-[var(--line)] bg-[var(--stone)] px-5 pb-8 pt-4 lg:hidden"
          >
            {[...links, ["kontakt", "Kontakt"]].map(([id, label], i) => (
              <button key={id} data-testid={`mobile-nav-link-${id}`} onClick={() => go(id)} className="flex w-full items-baseline justify-between border-b border-[var(--line)] py-4 text-left">
                <span className="font-serif-d text-3xl">{label}</span>
                <span className="font-mono-d text-xs text-[var(--ink-2)]">0{i + 1}</span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
